import { UpcomingAppointmentsModel } from "one-card-upcoming-appointments";

/**
 * 
 * @param count contains the total number of colors needed
 */
export const getColorCode = (count: number) => {
    let hexcodes: string[] = ['#fcfbd4','#c6f2aa','#f8a768','#f0c2b9','#a7b8d1'];
    return hexcodes.slice(0, count);
}

/**
 * This Function transforms the backend response
 * in the Data Model that supports the 
 * upcoming Appointments Component
 * @param response has the backend upcoming 
 * appointment response
 * @param context has settings etc..
 */

interface ProviderID {
    ID: string;
    Type:string;
    // ... other properties
  }
  interface DeptID {
    ID: string;
    Type:string;
    // ... other properties
  }
  interface VisitID {
    ID: string;
    Type:string;
    // ... other properties
  }
interface Provider{
    ProviderName: string,
    DepartmentName: string,
    Time: string,
    Duration: string,
    ProviderIDs: ProviderID[],
    DepartmentIDs: DeptID[],
    VisitTypeID:VisitID[]
}
export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */
    const { settings:{appointment_config:{filterAppointments}}} = context;

    let result: UpcomingAppointmentsModel = {};
        let totalupcomingappointments: number = 0;
        let noShowCount: number = 0;
        let pastCount: number = 0;
        let completecount: number = 0;
        let upcomingCount: number = 0;
        let cancelledCount: number = 0;
        let data = {};
        let note:string = "";
        let upappointment: any = [];
        if (response && response.length > 0) {
            response.map((ele: any) => {
                let presentdate: number = new Date().getTime();
                let ddate: string = ele.appointmentDate ? ele.appointmentDate.split('T')[0] : "";
                let dtime: string = ele.appointmentDate ? ele.appointmentDate .split('T')[1]: "";
                let apptdate: number = new Date(ddate.concat(" ").concat(dtime)).getTime();
                    if (ele.isNoshow === true) {
                        noShowCount = noShowCount + 1;
                    }
                    else if (presentdate <= apptdate && !ele.isCancelled && !ele.isNoShow && !ele.isDeleted) {
                        upcomingCount = upcomingCount + 1;
                    }
                    else if (presentdate > apptdate && !ele.isCancelled && !ele.isNoShow && ele.isDeleted ) {                               
                        pastCount = pastCount + 1;
                    }
                    else if (ele.isCancelled === true) {
                        cancelledCount = cancelledCount + 1;
                    }
            });
        }
        result['totalupcomingappointments'] = upcomingCount;
        result['totalcancelappointments'] = cancelledCount;
        result['totalnoshow'] = noShowCount;
        result['note'] = note;
        result['chartdata'] = {
                labels: ["No Shows", "Completed", "Arrived", "Scheduled","Canceled"],
                datasets: [{
                    data: [noShowCount,pastCount,completecount,upcomingCount,cancelledCount],
                    backgroundColor: getColorCode(5),
                }]
        }
    return result;


}